export default "__VITE_ASSET__CA_cqM_v__"